import { ButtonHTMLAttributes } from 'react';

export default function SecondaryButton({ type = 'button', className = '', disabled, children, ...props }: ButtonHTMLAttributes<HTMLButtonElement>) {
    return (
        <button
            {...props}
            type={type}
            className={
                `inline-flex items-center px-4 py-2 bg-background dark:bg-background-dark border border-secondary dark:border-secondary-dark rounded-md font-semibold text-xs text-text dark:text-text-dark uppercase tracking-widest shadow-sm hover:bg-highlight dark:hover:bg-highlight-dark focus:outline-none focus:ring-2 focus:ring-highlight dark:focus:ring-highlight-dark focus:ring-offset-2 dark:focus:ring-offset-background-dark disabled:opacity-25 transition ease-in-out duration-150 ${
                    disabled && 'opacity-25'
                } ` + className
            }
            disabled={disabled}
        >
            {children}
        </button>
    );
}
